/**
 * Group related requests so you can cancel them easily when they are no longer needed
 */
export class RequestBag {
    constructor() {
        this.requests = [];
    }
    static get(object) {
        return this.bags.get(object);
    }
    static getOrCreate(object) {
        var _a;
        return (_a = this.get(object)) !== null && _a !== void 0 ? _a : this.create(object);
    }
    static create(object) {
        const bag = new RequestBag();
        this.bags.set(object, bag);
        return bag;
    }
    addRequest(request) {
        this.requests.push(request);
    }
    removeRequest(request) {
        const index = this.requests.findIndex(r => r === request);
        if (index !== -1) {
            this.requests.splice(index, 1);
        }
    }
    cancel() {
        for (const request of this.requests) {
            request.cancel();
        }
        this.requests = [];
    }
}
/**
 * We use a WeakMap so all the requests can get garbage collected
 * when all references to an instance disappears.
 * Note: since this is javascript, we cannot automatically cancel all pending requests in a RequestBag
 * when the associated key is deallocated (it is possible in newer browsers, but with a high and unreliable delay);
 * So use the .cancel() method on the bag to stop all requests in a bag properly if they are no longer needed
 */
RequestBag.bags = new WeakMap();
//# sourceMappingURL=RequestBag.js.map